// extracted by mini-css-extract-plugin
export default {"link_primary":"linkButton_link_primary__N1QoF","link_dark":"linkButton_link_dark__HCuIF"};